import request from '@/utils/request'; // 查询预约  真实地址: /api/app/onlineBook/queryReservationConsultation

export function queryReservationConsultation(params) {
  return request('/api/commander/app/onlineBook/queryReservationConsultation', {
    method: 'post',
    data: params
  }, true // 不带前缀
  );
}